import React, { useState } from 'react';
import { getBoardNo, getBoardTypes, getGameTypes } from './settingsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../loading/LoadingSpinner';
import { Button } from '../../components/Button';
import { getLocalPlayer } from '../room/roomSlice';
import { Dialog } from '../../components/Dialog';

import './Settings.css';

export const Settings = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const boardTypes = useSelector(getBoardTypes);
  const gameTypes = useSelector(getGameTypes);
  const boardNo = useSelector(getBoardNo);
  const localPlayer = useSelector(getLocalPlayer);

  const [gameType, setGameType] = useState(0);
  const [boardType, setBoardType] = useState(0);
  const [players, setPlayers] = useState(2);
  const [name, setName] = useState(t('PLAYER_GAME', {player: localPlayer.name}));
  const [ranked, setRanked] = useState(true);

  const boardTypesOptions = Object.values(boardTypes).map((b) => {
    return <option value={b.id} key={b.id}>{b.name}</option>;
  });

  const gameTypesOptions = Object.values(gameTypes).map((g) => {
    return <option value={g.id} key={g.id}>{g.name}</option>;
  });

  const selectedGameType = gameTypes[gameType];
  const playerOptions = selectedGameType.players.map((p) => {
    return <option value={p} key={p}>{p}</option>;
  });

  // No invites for now:
  // <div><input type="checkbox" checked={inviteOnly} onChange={e => setInviteOnly(e.target.checked)}/></div>
  const inviteOnly = false;

  const loadingSpinner = boardNo === null ? <LoadingSpinner/> : null;

  return (
    <Dialog title={t('CREATE_NEW_GAME')} className="settings">
      <form onSubmit={(e) => { dispatch({ type: 'action/create', payload: {name: name, gameType: gameType, boardType: boardType, players: players, ranked: ranked, inviteOnly: inviteOnly} }); e.preventDefault();}}>
        <table>
          <tbody>
            <tr><td className="name">{t('NAME')}:</td><td><input type="text" value={name} onChange={e => setName(e.target.value)}/></td></tr>
            <tr><td className="name">{t('BOARD')}:</td><td><select value={boardType} onChange={e => setBoardType(parseInt(e.target.value))}>{boardTypesOptions}</select></td></tr>
            <tr><td className="name">{t('TEMPO')}:</td><td><select value={gameType} onChange={e => setGameType(parseInt(e.target.value))}>{gameTypesOptions}</select></td></tr>
            <tr><td className="name">{t('NUM_PLAYERS')}:</td><td><select value={players} onChange={e => setPlayers(parseInt(e.target.value))}>{playerOptions}</select></td></tr>
            <tr><td className="name">{t('RANKED')}:</td><td><input type="checkbox" checked={ranked} onChange={e => setRanked(e.target.checked)}/></td></tr>
            <tr><td className="name"></td><td><Button type="submit">{t('CONTINUE')}</Button> <Button type="button" onClick={(e) => dispatch({ type: 'action/abort' })}>{t('ABORT')}</Button></td></tr>
          </tbody>
        </table>
      </form>
      {loadingSpinner}
    </Dialog>
  );
}
